import { makeStyles } from '@material-ui/core/styles'
import HomeOutlineIcon from 'mdi-react/HomeOutlineIcon'
import { FC } from 'react'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    background: 'linear-gradient(135deg, #f3f8f1 0%, #dcebd7 100%)',
    color: theme.palette.primary.main,
    cursor: 'default'
  },
  icon: {
    display: 'flex',
    padding: 14,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.7)'
  },
  text: {
    fontFamily: 'CircularBold',
    fontSize: 15,
    color: '#3d7a35'
  }
}))

/** Stands in for the photos of a listing that has none yet */
const PhotoPlaceholder: FC<{ large?: boolean }> = ({ large }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <span className={classes.icon}>
        <HomeOutlineIcon size={large ? 44 : 32} />
      </span>
      <span className={classes.text} style={large ? { fontSize: 17 } : undefined}>
        Photos coming soon
      </span>
    </div>
  )
}

export default PhotoPlaceholder
